
import s from './chat/state'
import * as a from './chat/actions'
import * as m from './chat/mutations'
import * as g from './chat/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
